<template>
    <div class="searchbox__results searchbox__results--active"
        :class="className">

        <div v-if="options && options.length === 0"
            class="searchbox__result-item">
            <div class="searchbox__result-item-category">
                {{$t('UI.searchBox.noResults')}}
            </div>
        </div>

        <div
            class="searchbox__result-item"
            v-for="(item, index) in options"
            :key="item.id"
            @click="selectItem(item)"
            :class="{ 'searchbox__result-item--active': index === focusItemIndex }">
            <div class="searchbox__result-item-category">{{getTagLabel(item.tags)}}</div>
            <div class="searchbox__result-item-title">{{item.title}}</div>
            <div v-if="item.text" class="searchbox__result-item-info">{{item.text}}</div>
        </div>
    </div>
</template>

<script>
import { getTranslationIdForTagList } from '@/components/help/utils';

export default {
    props: {
        options: {
            type: Array,
            required: true
        },
        focusItemIndex: {
            type: Number,
            required: true
        },
        selectItem: {
            type: Function,
            required: true
        },
        isLoading: {
            type: Boolean
        },
        className: {
            type: String
        }
    },
    methods: {
        getTagLabel(tags) {
            if (tags) {
                return this.$t(getTranslationIdForTagList(tags));
            }
            return null;
        }
    }
}
</script>
